import { FunctionComponent, memo } from "react";
import { IProps } from "./tag-phrase-triggers.types";
import { Route, Switch } from "react-router-dom";
import urlJoin from "url-join";
import TagsList from "pages/tag-phrase-triggers/tags-list";
import { PageSidebar, PageSidebarContent, PageSidebarHeader } from "@edgetier/client-components";
import { Permission, TagGroupType } from "@edgetier/watchtower-types";
import PageRoute from "constants/page";
import PhraseTriggers from "./phrase-triggers";
import EditPhraseTrigger from "./phrase-triggers/edit-phrase-trigger";
import PhraseTriggersPerformanceReport from "./phrase-triggers-performance-report";
import { PhraseTriggerContextProvider } from "components-for/phrase-triggers/phrase-trigger-context/phrase-trigger-provider";
import "./tag-phrase-triggers.scss";

/**
 * A screen for viewing and editing a tag's phrase triggers.
 */
const TagPhraseTriggers: FunctionComponent<IProps> = () => {
    return (
        <>
            <PageSidebar>
                <PageSidebarHeader title="Tag Groups" />
                <PageSidebarContent>
                    <TagsList
                        tagGroupType={TagGroupType.PhraseSearch}
                        redirectRoute={PageRoute.ManageTags}
                        showExploreAction={true}
                        actionPermissions={Permission.ManagePhraseTriggers}
                    />
                </PageSidebarContent>
            </PageSidebar>
            <PhraseTriggerContextProvider>
                <Switch>
                    <Route exact path={urlJoin(PageRoute.ManageTags, ":tagId?")}>
                        <PhraseTriggers />
                    </Route>
                    <Route exact path={urlJoin(PageRoute.ManagePhraseTriggers, ":phraseTriggerId?")}>
                        <EditPhraseTrigger />
                    </Route>
                    <Route exact path={PageRoute.PhraseTriggersReport}>
                        <PhraseTriggersPerformanceReport />
                    </Route>
                </Switch>
            </PhraseTriggerContextProvider>
        </>
    );
};

export default memo(TagPhraseTriggers);
